import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Link from 'valuelink';
import { Popconfirm, message, Button } from 'antd';
import { Input } from 'valuelink/lib/tags';
import { RegularText, SemiboldText } from '../../components/common/Text';
import { setDoctorProfile } from '../../actions/index';
import {
  fetchDoctorRegistrations,
  deleteRegistration,
  updateRegistration,
} from '../../services';

const OuterContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
`;

const TitleText = styled(SemiboldText)`
  font-size: 1.5rem;
  text-align: center;
  color: #666569;
`;

const ColContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const BodyContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 20px;
  /* over */
`;

const StyledInputBox = styled(Input)`
  font-size: 16px !important;
  background-color: #f8f8f8;
  align-self: stretch;
  border-radius: 6px;
  flex: 1;
  flex-shrink: 0;
  min-width: 180px;
  /* max-width: 380px; */
  height: 44px;
  padding: 6px 12px;
  align-items: center;
  margin-bottom: 10px;
`;

const LabelText = styled(SemiboldText)`
  font-size: 12px;
  text-align: center;
  margin-bottom: 0.25rem;
  margin-top: 0.625rem;
  color: #7c7c7c;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
`;

const RegistrationRow = styled.div`
  display: flex;
  flex-direction: row;
  margin: 16px;
  padding: 8px;
  box-shadow: 0 3px 5px 2px rgba(0, 0, 0, 0.1);
  border-radius: 0.5rem;
  align-items: center;
  justify-content: space-between;
`;

const RegistrationNumber = styled(SemiboldText)`
  font-size: 16;
  color: #666569;
`;

const RegistrationInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const RegistrationText = styled(RegularText)`
  font-size: 14;
  color: #666569;
  margin: 0px 10px 0px 10px;
`;

const EduRowComponent = styled.div`
  display: flex;
  flex-direction: row;
`;

class DoctorRegistrationsScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      registrations: [],
      doctorRegistrationId: null,
      title: '',
      year: '',
      formEditing: false,
    };
    console.log({ props });

    this.doctorId = props.doctorId;
  }

  componentDidMount = () => {
    this.fetchRegistration();
  };

  componentDidUpdate = () => {
    if (document.getElementById('edit-form')) {
      document.getElementById('edit-form').scrollIntoView();
    }
  };

  fetchRegistration = () => {
    const { dispatch } = this.props;
    fetchDoctorRegistrations(this.doctorId).then(res => {
      const registrations = res.data;
      dispatch(setDoctorProfile({ registrations }));
      this.setState({
        registrations,
      });
    });
  };

  submit = () => {
    const { doctorRegistrationId, title, year } = this.state;

    updateRegistration({
      doctorId: this.doctorId,
      doctorRegistrationId,
      title,
      year,
    })
      .then(() => {
        this.cancelEditing();
        this.fetchRegistration();
      })
      .catch(err => {
        console.log({ err });
      });
  };

  deleteRegistration = doctorRegistrationId => {
    deleteRegistration(this.doctorId, doctorRegistrationId)
      .then(() => {
        message.success('Registration deleted successfully');
        this.fetchRegistration();
      })
      .catch(err => {
        console.log({ err });
      });
  };

  editRegistration = edu => {
    this.setState({
      formEditing: true,
      doctorRegistrationId: edu.doctorRegistrationId,
      title: edu.title || '',
      year: edu.year || '',
    });
  };

  cancelEditing = () => {
    this.setState({
      formEditing: false,
      doctorRegistrationId: null,
      title: '',
      year: '',
    });
  };

  render() {
    const { registrations } = this.state;
    const titleLink = Link.state(this, 'title');
    const yearLink = Link.state(this, 'year');

    const registrationsForm = () => {
      console.log({ state: this.state });
      return (
        <RegistrationRow id="edit-form">
          <BodyContainer>
            <LabelText>Registration Title</LabelText>
            <StyledInputBox
              className="visit-input"
              valueLink={titleLink}
              placeholder="Title"
            />

            <LabelText>year</LabelText>
            <StyledInputBox
              type="tel"
              className="visit-input"
              valueLink={yearLink}
              placeholder="year"
              maxLength={4}
            />

            <EduRowComponent>
              <Button
                type="primary"
                style={{ marginRight: 10 }}
                onClick={this.submit}
              >
                Submit
              </Button>
              <Button onClick={this.cancelEditing}>Cancel</Button>
            </EduRowComponent>
          </BodyContainer>
        </RegistrationRow>
      );
    };

    const renderRegistration = (edu, idx) => (
      <RegistrationRow>
        <EduRowComponent>
          <RegistrationNumber>{idx + 1}. </RegistrationNumber>
          <RegistrationInfo>
            <RegistrationText>{edu.title}</RegistrationText>
            <RegistrationText>{`${edu.year}`}</RegistrationText>
          </RegistrationInfo>
        </EduRowComponent>
        <EduRowComponent>
          <Button
            type="primary"
            style={{ marginRight: 10 }}
            onClick={() => this.editRegistration(edu)}
          >
            Edit
          </Button>
          <Popconfirm
            title="Are you sure delete this?"
            onConfirm={() => this.deleteRegistration(edu.doctorRegistrationId)}
            // onCancel={cancel}
            okText="Yes"
            cancelText="No"
          >
            <Button type="danger">Delete</Button>
          </Popconfirm>
        </EduRowComponent>
      </RegistrationRow>
    );

    return (
      <OuterContainer>
        <TitleText>Doctor Registration Screen</TitleText>
        <ColContainer>{registrations.map(renderRegistration)}</ColContainer>
        {!this.state.formEditing && (
          <Button
            style={{ alignSelf: 'center', flex: 0, padding: 4 }}
            onClick={() => this.editRegistration({})}
          >
            Add Registration
          </Button>
        )}
        {this.state.formEditing && registrationsForm()}
      </OuterContainer>
    );
  }
}

const mapStateToProps = state => ({
  authToken: state.user.authToken,
});

export default connect(mapStateToProps)(DoctorRegistrationsScreen);
